// docs: https://github.com/altostra/type-validations#readme
import { recordOf, tupleOf } from "@altostra/type-validations";
import { number } from "@altostra/type-validations/lib/primitives";

const dataPoint = tupleOf(number, number);

export const isAnalyticsDashboardAppGroupIdCreditConsumptionTimePeriodDataResult = recordOf({
  value: dataPoint,
});
